const getCookieValue = (name: string) => {
	const nameLenPlus = name.length + 1
	return (
		document.cookie
			.split(';')
			.map((c) => c.trim())
			.filter((cookie) => cookie.startsWith(name))
			.map((cookie) => decodeURIComponent(cookie.substring(nameLenPlus)))[0] || null
	)
}

const combineUrlAndCookieValues = (cookieValue?: string | null, urlValue?: string | null) => {
	const hasCookieValue = cookieValue && cookieValue !== ''
	const hasUrlValue = urlValue && urlValue !== ''

	if (!hasCookieValue && !hasUrlValue) return

	if (hasCookieValue && hasUrlValue) {
		const cookieValueParts = cookieValue
			.split('-')
			.filter((part: string) => part !== urlValue)
			.concat([urlValue])
		if (cookieValueParts.length > 10) {
			return cookieValueParts.slice(-10, 0).join('-')
		}

		return cookieValueParts.join('-')
	}

	if (hasCookieValue) return cookieValue
	if (hasUrlValue) return urlValue

	return
}

export const getAdvertisementCode = () => {
	const urlParams = new URLSearchParams(window.location.search)
	const urlCode = urlParams.get('wc')
	const cookieCode = getCookieValue('bstatus')

	return combineUrlAndCookieValues(cookieCode, urlCode)
}
